import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.isEmbedded()) {
      document.documentElement.classList.add("embedded")
      document.body.classList.add("embedded")
    }
  }

  isEmbedded() {
    try {
      return window.self !== window.top
    } catch (_) {
      return true // cross-origin → embedded
    }
  }
}
